"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
exports.FetchContext = react_1.createContext({
    url: '',
    options: {},
    graphql: false,
});
exports.default = exports.FetchContext;
//# sourceMappingURL=FetchContext.js.map